/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifactpackprogressempty3Inputs */

const en_artifactpackprogressempty3 = /** @type {(inputs: Artifactpackprogressempty3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Once your timeline and documents are in, the pack is one click away.`)
};

const pt_artifactpackprogressempty3 = /** @type {(inputs: Artifactpackprogressempty3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assim que tiver a cronologia e os documentos prontos, o pack fica a um clique.`)
};

/**
* | output |
* | --- |
* | "Once your timeline and documents are in, the pack is one click away." |
*
* @param {Artifactpackprogressempty3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const artifactpackprogressempty3 = /** @type {((inputs?: Artifactpackprogressempty3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifactpackprogressempty3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_artifactpackprogressempty3(inputs)
	return pt_artifactpackprogressempty3(inputs)
});
export { artifactpackprogressempty3 as "artifactPackProgressEmpty" }